import { render, staticRenderFns } from "./platform-dialog.vue?vue&type=template&id=425076c4&"
import script from "./platform-dialog.vue?vue&type=script&lang=js&"
export * from "./platform-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports